import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";
import {choose_template} from "./choose_template";


export async function templated_reply_all_message(e) {
    return templated_reply_message(e, true);
}

export async function reply_all_message(e) {
    return reply_message(e, true);
}

export async function templated_reply_message(bound_entity, replyall) {
    let message = await HalResource(bound_entity);
    let engine = bound_entity && bound_entity.engine_s;

    let parent_entity = await HalResource(bound_entity)
        .follow("parent");
    console.log("Entity:", parent_entity);
    let template = await choose_template(parent_entity, engine || "email");
    if (!template) {
        uly.utils.show_results({
            "success": false,
            "error": _("communications_no_template_for_email", "No templates have been defined for email")
        });
        return;
    }

    var res = null;
    if (message && message.related_id_s) {
        var entity = message.related_id_s.split("#");
        res = uly.api.start().follow_with_cache("uly:data").follow("find", {
            "rel": entity[0] + "/" + entity[1]
        });
        //res = HalResource(uly.api.fetch_entity(entity.related_id_s));
    } else {
        res = HalResource(message);
    }
    let newmessage_resource = res.follow("uly:replymessage", {
        "template": template,
        "replyall": replyall || false,
        "channel": engine || "email"
    });

    let result = await newmessage_resource;
    if (result.success === false) {
        return uly.utils.show_results(result);
    }

    let newmessage = HalResource(result);
    return uly.dialogs.execute(
        result.dialog_markup, 
        {
            "title": _("communications_title_reply_message", "Reply To Message")
        }, 
        $.extend({
            "recipient": null,
            "title": null,
            "document": null,
            "cc": null,
            "bcc": null,
            "from_address": null,
            "uploads_id__uploads": []
        }, result.message_data)
    ).then(([result]) => {
        result.message_engine = result.message_engine || engine || "email";
        newmessage
            .post(null, ko.toJS(result))
            .always(uly.utils.show_results)
            .then((_result) => {
                    //posted...
                    uly.publish("entity.modified", parent_entity);
            });
    });

    
}

export function reply_message(bound_entity, replyall) {
    HalResource(bound_entity).then((entity) => {
        var res = null;
        if (entity && entity.related_id_s) {
            var entity = entity.related_id_s.split("#");
            res = uly.api.start().follow_with_cache("uly:data").follow("find", {
                "rel": entity[0] + "/" + entity[1]
            });
            //res = HalResource(uly.api.fetch_entity(entity.related_id_s));
        } else {
            res = HalResource(entity);
        }
        let newmessage_resource = res.follow("uly:replymessage", { "replyall": replyall || false });
        return newmessage_resource.then((result) => {
            if (result.success === false) {
                return uly.utils.show_results(result);
            }
            var newmessage_resource = HalResource(result);
            uly.dialogs.execute(result.dialog_markup, {
                "title": _("communications_title_reply_message", "Reply To Message")
            }, $.extend({
                "recipient": null,
                "title": null,
                "document": null,
                "cc": null,
                "bcc": null,
                "from_address": null,
                "uploads_id__uploads": []
            }, result.message_data))
                .then(function ([result]) {
                    newmessage_resource.post(null, ko.toJS(result)).always(uly.utils.show_results).done(function (result) {
                        //posted...
                        uly.publish("entity.modified", bound_entity);
                    });
                });
        });
    });
};


export function forward_message(bound_entity) {
    HalResource(bound_entity).then((entity) => {
        var res = null;
        if (entity && entity.related_id_s) {
            var entity = entity.related_id_s.split("#");
            res = uly.api.start().follow_with_cache("uly:data").follow("find", {
                "rel": entity[0] + "/" + entity[1]
            });
            //res = HalResource(uly.api.fetch_entity(entity.related_id_s));
        } else {
            res = HalResource(entity);
        }
        let newmessage_resource = res.follow("uly:forwardmessage");
        return newmessage_resource.then((result) => {
            if (result.success === false) {
                return uly.utils.show_results(result);
            }
            var newmessage_resource = HalResource(result);
            uly.dialogs.execute(result.dialog_markup, {
                "title": _("communications_title_forward_message", "Forward Message")
            }, $.extend({
                "recipient": null,
                "title": null,
                "document": null,
                "cc": null,
                "bcc": null,
                "from_address": null,
                "uploads_id__uploads": []
            }, result.message_data))
                .then(function ([result]) {
                    newmessage_resource.post(null, ko.toJS(result)).always(uly.utils.show_results).done(function (result) {
                        //posted...
                        uly.publish("entity.modified", bound_entity);
                    });
                });
        });
    });

};